// Vendor
import { createAction, props } from '@ngrx/store';
export const setChartAnnotation = createAction('[Fund Chart] Set chart annotation', props());
export const removeChartAnnotation = createAction('[Fund Chart] Remove chart annotation', props());
export const clearChartAnnotations = createAction('[Fund Chart] Clear chart annotations');
